/** Outbound notification medium — distinct from sales channel (`sales-channel.ts`). */
export const NOTIFICATION_CHANNELS = ['EMAIL', 'WHATSAPP'] as const;
export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

export function isNotificationChannel(value: string): value is NotificationChannel {
  return (NOTIFICATION_CHANNELS as readonly string[]).includes(value);
}

export function notificationChannelLabel(channel: NotificationChannel | string | null | undefined): string {
  switch (channel) {
    case 'EMAIL':
      return 'E-mail';
    case 'WHATSAPP':
      return 'WhatsApp';
    default:
      return channel?.trim() || '—';
  }
}
